"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/CallControls/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);












// `type` is unset for the generic buttons: the class name then reads
// `…--icon--undefined`, as in JS.
const buildIconClassName = (
  className, type, isActive, ...classNames
) => _classBuilder2.default.call(void 0, 
  "video-call--call-controls--icon",
  `video-call--call-controls--icon--${type}`,
  className,
  { active: isActive },
  ...classNames,
)

const activeIconClassName = (isActive) => _classBuilder2.default.call(void 0, { hidden: !isActive })
const inactiveIconClassName = (isActive) => _classBuilder2.default.call(void 0, { hidden: isActive })

 const SwitchCamBtn = _react2.default.forwardRef(
  ({ onClick, className }, ref) => (
    _react2.default.createElement('div', {
      ref: ref,
      className: buildIconClassName(className, 'switch-cam'),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}

      , _react2.default.createElement('img', { src: "/assets/icons/video/switch-cam.svg", alt: "Switch cam" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
    )
  ),
); exports.SwitchCamBtn = SwitchCamBtn

 const DisableCamBtn = _react2.default.forwardRef(
  ({ onClick, className, isActive }, ref) => (
    _react2.default.createElement('div', {
      ref: ref,
      className: buildIconClassName(className, 'toggle-cam', isActive),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}

      , _react2.default.createElement('img', {
        src: "/assets/icons/video/cam-off-black.svg",
        alt: "Disable cam" ,
        className: activeIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      )
      , _react2.default.createElement('img', {
        src: "/assets/icons/video/cam-off-white.svg",
        alt: "Enable cam" ,
        className: inactiveIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
      )
    )
  ),
); exports.DisableCamBtn = DisableCamBtn

 const DisableMicBtn = _react2.default.forwardRef(
  ({ onClick, className, isActive }, ref) => (
    _react2.default.createElement('div', {
      ref: ref,
      className: buildIconClassName(className, 'toggle-mic', isActive),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}

      , _react2.default.createElement('img', {
        src: "/assets/icons/video/mic-off-black.svg",
        alt: "Disable mic" ,
        className: activeIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      )
      , _react2.default.createElement('img', {
        src: "/assets/icons/video/mic-off-white.svg",
        alt: "Enable mic" ,
        className: inactiveIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
      )
    )
  ),
); exports.DisableMicBtn = DisableMicBtn

 const ScreenSharingBtn = _react2.default.forwardRef(
  ({ onClick, className, isActive }, ref) => (
    _react2.default.createElement('div', {
      ref: ref,
      className: buildIconClassName(
        className,
        'toggle-screen',
        isActive,
        "video-call--call-controls--screen-sharing-icon",
      ),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}

      , _react2.default.createElement('img', {
        src: "/assets/icons/video/screen-share-black.svg",
        alt: "Disable scr" ,
        className: activeIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
      )
      , _react2.default.createElement('img', {
        src: "/assets/icons/video/screen-share-white.svg",
        alt: "Enable scr" ,
        className: inactiveIconClassName(isActive), __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
      )
    )
  ),
); exports.ScreenSharingBtn = ScreenSharingBtn

 const GenericBtn = _react2.default.forwardRef(
  ({ onClick, className, iconSrc, iconAlt }, ref) => {
    const rootClassName = buildIconClassName(className)
    return (
      _react2.default.createElement('div', { ref: ref, onClick: onClick, className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
        ,  iconSrc &&
          _react2.default.createElement('img', { src: iconSrc, alt: iconAlt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}} )
        
      )
    )
  },
); exports.GenericBtn = GenericBtn

 const MinimizeCallBtn = _react2.default.forwardRef(
  ({ onClick }, ref) => (
    _react2.default.createElement('div', {
      ref: ref,
      onClick: onClick,
      className: "meeting--on-call--minimize-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
    )
  ),
); exports.MinimizeCallBtn = MinimizeCallBtn

 const PinActiveSpeakerBtn = _react2.default.forwardRef(
  ({ onClick, isActive }, ref) => {
    const rootClassName = _classBuilder2.default.call(void 0, 
      "meeting--on-call--pin-btn",
      { active: isActive },
    )
    return (
      _react2.default.createElement('div', { ref: ref, onClick: onClick, className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}} )
    )
  },
); exports.PinActiveSpeakerBtn = PinActiveSpeakerBtn

 const HangupBtn = _react2.default.forwardRef(
  ({ onClick, className }, ref) => {
    const rootClassName = _classBuilder2.default.call(void 0, 
      buildIconClassName(className),
      "video-call--call-controls--icon-hangup",
    )
    return (
      _react2.default.createElement('div', {
        ref: ref,
        className: rootClassName,
        onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}

        , _react2.default.createElement('img', { src: "/assets/icons/video/hang-up.svg", alt: "Hang up" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}} )
      )
    )
  },
); exports.HangupBtn = HangupBtn
